import { defineComponent as _defineComponent } from 'vue'
import MyProjectsSectionHeader from '@/views/my-projects/components/MyProjectsSectionHeader.vue';
import { computed, ref, watchEffect } from 'vue';
import { updateContractReference } from '@/services/ContractService';
import useContract from '@/views/my-projects/composables/useContract';
import useI18n from '@/mixins/useI18n';
import BCXForm from '@/components/molecules/forms/BCXForm.vue';
import EditIcon from '@/components/molecules/EditIcon.vue';
import { BcxFormField } from '@/models/BcxForm';
import usePageState from '@/state/pageState';
import { logError } from '@/utils/logger';
import useUser from '@/mixins/useUser';
import ConfirmButtons from '@/components/molecules/ConfirmButtons.vue';
import { RawLocation } from 'vue-router';
import BCXHelpTextTriggerIcon from '@/components/molecules/BCXHelpTextTriggerIcon.vue';
import BCXInfoCollapsible from '@/components/molecules/BCXInfoCollapsible.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsContractContract',
  setup(__props) {

const isHelpOpen = ref(false);

const { t } = useI18n();
const { globalErrorMessage } = usePageState();

const { userId } = useUser('self');

const {
  contractDetail,
  isContractStatusOpen,
  referenceFieldData,
} = useContract();

const localReferenceFieldData = ref({ ...referenceFieldData.value });
const referenceFormField = ref<BcxFormField[]>([
  {
    type: 'text',
    label: t('contracts.contract.contract-header.reference')
      .toString(),
    name: 'reference',
    width: '100%',
    textOptions: {
      maxLength: 60
    }
  }
]);
const projectTitle = computed(() => contractDetail.value?.projectOffer?.project?.title ?? '');
const canReferenceBeEdited = computed(() => contractDetail.value?.creator === userId.value);
const projectLink = computed((): RawLocation => ({
  name: 'projectForumThread',
  params: { projectId: contractDetail.value?.projectOffer?.project?.id ?? '' }
}));

const isEditingReference = ref(false);
const toggleIsEditingReference = () => {
  isEditingReference.value = !isEditingReference.value;
};

const classDependingOnStatus = computed(() => {
  const status = contractDetail.value?.status;
  if (!status) {
    return '';
  }

  switch (status) {
    case 'OPEN':
      return 'mp-contract-status-open';
    case 'SIGNED':
      return 'mp-contract-status-signed';
    case 'CANCELLED':
      return 'mp-contract-status-cancelled';
    case 'ENDED':
      return 'mp-contract-status-ended';
    case 'RUNNING':
      return 'mp-contract-status-running';
    default:
      return 'mp-contract-status-open';
  }
});

const saveReference = async () => {
  try {
    if (contractDetail.value) {
      await updateContractReference(contractDetail.value?.contractId, localReferenceFieldData.value.reference);
      referenceFieldData.value = localReferenceFieldData.value;
    }
    toggleIsEditingReference();
  } catch (e: any) {
    globalErrorMessage.value = {
      code: e.response.data.error.code.substring(0, (e.response.data.error.code.length > 30 ? 30 : e.response.data.error.code.length - 1)),
      component: 'MyProjectsContractDocuments.vue',
      withoutReload: true,
      i18Key: 'common.unknownError'
    };
    logError(e.response.data.error.code);
  }
};

// In the event of an abort, the old memory statuses are restored
const referenceProcessingAborted = () => {
  toggleIsEditingReference();
  localReferenceFieldData.value = { ...referenceFieldData.value };
};

// If reactive data changes, it is updated
watchEffect(() => {
  localReferenceFieldData.value = { ...referenceFieldData.value };
});

return { __sfc: true,isHelpOpen, t, globalErrorMessage, userId, contractDetail, isContractStatusOpen, referenceFieldData, localReferenceFieldData, referenceFormField, projectTitle, canReferenceBeEdited, projectLink, isEditingReference, toggleIsEditingReference, classDependingOnStatus, saveReference, referenceProcessingAborted, MyProjectsSectionHeader, BCXForm, EditIcon, ConfirmButtons, BCXHelpTextTriggerIcon, BCXInfoCollapsible }
}

})